import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
import { AUTHORIZATION_CODE_STORAGE_KEY, AUTH_REDIRECT_URL_STORAGE_KEY, AUTH_REDIRECT_URI_STORAGE_KEY, CODE_VERIFIER_STORAGE_KEY, AUTH_STATE_STORAGE_KEY, ID_TOKEN_STORAGE_KEY, NONCE_STORAGE_KEY, USER_TOKEN_STORAGE_KEY } from '../constants';
import { OidcAccessToken } from '../tokens/OidcAccessToken';
import { OidcIdToken } from '../tokens/OidcIdToken';
import { singleton } from '../utils/singleton';
import { SessionValue } from './SessionValue';
export let OidcTokenStorage = singleton(_class = class OidcTokenStorage {
  constructor() {
    _defineProperty(this, "authorizationCode", new SessionValue(AUTHORIZATION_CODE_STORAGE_KEY));
    _defineProperty(this, "accessToken", new SessionValue(USER_TOKEN_STORAGE_KEY));
    _defineProperty(this, "idToken", new SessionValue(ID_TOKEN_STORAGE_KEY));
    _defineProperty(this, "redirectUrl", new SessionValue(AUTH_REDIRECT_URL_STORAGE_KEY));
    _defineProperty(this, "redirectUri", new SessionValue(AUTH_REDIRECT_URI_STORAGE_KEY));
    _defineProperty(this, "codeVerifier", new SessionValue(CODE_VERIFIER_STORAGE_KEY));
    _defineProperty(this, "state", new SessionValue(AUTH_STATE_STORAGE_KEY));
    _defineProperty(this, "nonce", new SessionValue(NONCE_STORAGE_KEY));
    _defineProperty(this, "getAccessToken", () => {
      const token = this.accessToken.get();
      if (token !== null) {
        return new OidcAccessToken(token);
      }
      return null;
    });
    _defineProperty(this, "setAccessToken", oidcToken => {
      this.accessToken.set(oidcToken.toString());
      return this;
    });
    _defineProperty(this, "getIdToken", () => {
      const token = this.idToken.get();
      if (token !== null) {
        return new OidcIdToken(token);
      }
      return null;
    });
    _defineProperty(this, "setIdToken", oidcIdToken => {
      this.idToken.set(oidcIdToken.toString());
      return this;
    });
  }
}) || _class;
//# sourceMappingURL=OidcTokenStorage.js.map